import React, { Suspense } from 'react';
import { Navigate, Outlet, To } from 'react-router-dom';
import styled from 'styled-components';

import PrivateLayout from 'src/Layouts/Private';
import { Spinner } from 'src/UIComponents';
import { useUser } from 'src/queries/user';

const StyledSpinner = styled(Spinner)`
  width: 100%;
  margin-top: 2em;
`;

type PrivateRouteProps = {
  fullscreen?: boolean;
  redirectPath?: To;
};

// https://ui.dev/react-router-v5-protected-routes-authentication
function PrivateRoute({
  fullscreen,
  redirectPath = '/login',
}: PrivateRouteProps) {
  const { isLoading: loadingUser, data: user } = useUser('me');

  if (loadingUser) {
    return <StyledSpinner />;
  }

  if (!user) {
    return <Navigate to={redirectPath} replace />;
  }

  return (
    <PrivateLayout fullscreen={fullscreen}>
      <Suspense
        fallback={
          <Spinner
            style={{
              width: '100%',
              height: '80px',
            }}
          />
        }
      >
        <Outlet />
      </Suspense>
    </PrivateLayout>
  );
}

export default PrivateRoute;
